import ForgotPassword from "./forgotPassword";
import UpdatePasswordForm from "./updatePasswordForm";
import VerifyEmailForm from "./verifyEmailForm";

export { ForgotPassword, UpdatePasswordForm, VerifyEmailForm };
export default ForgotPassword;
